import { FormattedMessage } from 'react-intl';

import messages from './BalanceAfterTopup.messages';
import { MoneyWithDecimals } from '../../../../ui/moneyWithDecimals';
import SummaryRow from '../../../../ui/summaryRow/SummaryRow';

const BalanceAfterTopup = ({
    totalBalance,
    isLoading
}: {
    totalBalance: number;
    isLoading: boolean;
}) => (
    <SummaryRow isLoading={isLoading}>
        <FormattedMessage {...messages.totalRepayment} />
        <span data-testid="early-repayment-total">
            <MoneyWithDecimals value={totalBalance} />
        </span>
    </SummaryRow>
);

// eslint-disable-next-line import/no-default-export
export default BalanceAfterTopup;
